import React, { Component } from "react";

import { ShuffleArray } from "../../../helpers/functions";
import data from "../../../data/cities.json";
// import { firestore } from "src/helpers/Firebase";
class RelatePartners extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      cities: ShuffleArray(
        data.cities.filter(
          (x) => x.partnerStatus === "Active" && x.ID !== props.currentID
        )
      )
        .splice(0, 6)
        .map((y) => ({ id: y.ID, ...y })),
    };
  }

  // FirebaseRemoved
  // componentDidMount() {
  //   this.loadCities();
  // }

  // async loadCities() {
  //   const { currentID } = this.props;

  //   firestore
  //     .collection("Web/Corporate/DataBase/Cities/DataBase")
  //     .where("partnerStatus", "==", "Active")
  //     .limit(6)
  //     .get()
  //     .then((querySnapshot) => {
  //       const cities = [];

  //       querySnapshot.forEach((doc) => {
  //         if (currentID !== doc.id) cities.push({ ...doc.data(), id: doc.id });
  //       });

  //       this.setState({ cities, loading: false });
  //     });
  // }

  render() {
    const { cities, loading } = this.state;

    return (
      <div
        className="themesflat-carousel-box data-effect has-arrows arrow-top arrow75 arrow-circle arrow-style-2 clearfix"
        data-gap={30}
        data-column={3}
        data-column2={2}
        data-column3={1}
        data-auto="false"
      >
        <div className="owl-carousel owl-theme">
          {loading ? (
            <div />
          ) : (
            cities.map((data) => {
              return (
                <a
                  href={
                    data.partnerStatus == "Active"
                      ? "/partner-about?id=" +
                        data.id +
                        "&name=" +
                        data.partnerName
                      : "#"
                  }
                >
                  <div
                    className="themesflat-project style-1 clearfix"
                    key={data.id}
                  >
                    <div className="project-item">
                      <div className="inner">
                        <div className="thumb data-effect-item has-effect-icon w40 offset-v-43 offset-h-46">
                          <img
                            src={data.listImg}
                            alt={`${data.partnerName} - CityX`}
                          />
                          <div className="text-wrap text-center">
                            <h5 className="heading">{data.partnerName}</h5>
                            <div className="elm-meta">
                              <span style={{ color: "white" }}>
                                {data.country}
                              </span>
                              <span style={{ color: "white" }}>
                                {data.partnerType}
                              </span>
                            </div>
                          </div>

                          <div className="overlay-effect bg-color-1" />
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              );
            })
          )}
        </div>
      </div>
    );
  }
}

export default RelatePartners;
